module.exports = __webpack_public_path__ + "static/03-52a11033b1f5c9aa5bdd3805bed42679.jpg";